export default __webpack_public_path__ + "static/media/dds5168b-2.f3588dfe.png";